import ProductOrderPurchaseCostResponse from "./ProductOrderPurchaseCostResponse";

class ProductOrderProfitOverviewResponse {
    public totalPurchaseCost: number;
    public totalServiceCost: number;
    public totalProfit: number;
    public ordersAmount: number;
    public orders?: ProductOrderPurchaseCostResponse[];

    constructor(
        totalPurchaseCost: number,
        totalServiceCost: number,
        totalProfit: number,
        ordersAmount: number,
        orders?: ProductOrderPurchaseCostResponse[]
    ) {
        this.totalPurchaseCost = totalPurchaseCost;
        this.totalServiceCost = totalServiceCost;
        this.totalProfit = totalProfit;
        this.ordersAmount = ordersAmount;
        this.orders = orders;
    }

}

export default ProductOrderProfitOverviewResponse;